export enum LinkUrlPrefixEnum {
  Article = "articles",
  Catalog = "catalog",
  Category = "category",
  Gid = "gidy",
  Goroskop = "goroskop",
  Landing = "landing",
  Product = "product",
  Email = "email"
}

export type SeoAdminLinkType = {
  customDisplayName: string;
  data: {
    documentId: number;
    URL: string,
    breadcrumbDisplayName?: string;
    linkDisplayName: string;
    publishedAt: string;
  }
};

export enum SeoExpertsCardModeEnum {
  NoChat = "NoChat",
  Standard = "Standard",
}
